import * as yup from 'yup';
import * as errorMsg from '../constants/validationMessages';
import constraints from '../constants/validationConstraints';

export const contactNameValidation = (label) => yup.string()
  .max(constraints.CONTACT_NM_MAX, errorMsg.MAX_ERROR(label, constraints.CONTACT_NM_MAX))
  .min(constraints.CONTACT_NM_MIN, errorMsg.MIN_ERROR(label, constraints.CONTACT_NM_MIN))
  .matches(constraints.CONTACT_NM_REGEX, errorMsg.CTC_NAME_REGEX_ERROR(label))
  .trim()
  .required(errorMsg.REQUIRED_ERROR(label));
